import axios from '@/framework/router/axios'
import { setOrderItemList } from '@/framework/components/user/api'

// /account/login-name

const apiJobDicList = async() => {
  // url  /pub/dm-const/listByCataCode
  // cataCode : orgType
  return axios.get('/pub/dm-const/listByCataCode', {
    params: {
      cataCode: 'orgType'
    }
  })
}

const apiJobListByorgType = async(orgType) => {
  return axios.post('/org/list-position', null, {
    params: { orgType }
  })
}

const apiJobQueryByorgSubjectId = async(postdata, column, params) => {
  // permissionSubjectId === orgSubjectId
  let orderItemList = setOrderItemList(column)
  return axios.post('/oru/query-by-org-subject-id', { entity: postdata, orderItemList }, {
    params
  })
}

const apiJobORUAdd = async({
  orgSubjectId,
  roleSubjectIdList,
  userSubjectIdList
}) => {
  return axios.post('/oru', null, {
    params: {
      orgSubjectId,
      roleSubjectIdList,
      userSubjectIdList
    }
  })
}

const apiJobORUDelete = async(idList) => {
  return axios.post('/oru/delete', null, {
    params: {
      idList
    }
  })
}

export default {
  apiJobQueryByorgSubjectId,
  apiJobDicList,
  apiJobListByorgType,
  apiJobORUAdd,
  apiJobORUDelete
}
